module.exports = __webpack_public_path__ + "img/iPhone12Mini.35fcd637.png";